import React from 'react'
import SystemLabelMasterCollection from './../../collections/system_label_master_collection'

const SelectFuelType = (props) => {

  const handleChange = (e) => {
    props.actions.changeSelectFuelType({
      selectFuelType: e.target.value,
    })
  }
  const { payload } = props.systemLabelMastersApiResult
  if (!payload) {
    return null
  }
  const systemLabelMasterCollection = new SystemLabelMasterCollection(payload)
  const { selectFuelType } = props
  return (
    <div className='searchArea__item'>
      <h3 className='searchArea__title'>{TRUCKERS.LANG.ITEM.FUEL_TYPE}</h3>
      <p className='selectWrap searchArea__item__inner'>
        <select
          className="select"
          value={selectFuelType}
          onChange={handleChange}
        >
          <option value="">{TRUCKERS.LANG.ITEM.LIST_SEARCH.SELECT_WITH_CLICK}</option>
          {
            systemLabelMasterCollection.getValueList('item', 'fuel_type').map(i => {
              const labelKey = i.get('label_key')
              return <option key={labelKey} value={labelKey}>{i.getValueI18n()}</option>
            })
          }
        </select>
      </p>
    </div>
  )
}
export default SelectFuelType;
